export default __webpack_public_path__ + "static/media/accident-page-3.6215a9a1.png";